import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {
  getWorkforceProfileHighlightDotColor,
  type WorkforceProfileHighlightVariant,
} from '../../utils/WorkforceProfileDetail/getWorkforceProfileHighlightDotColor';

export interface Props {
  item: string;
  variant: WorkforceProfileHighlightVariant;
  showDivider: boolean;
}

export const WorkforceProfileHighlightItem = ({item, variant, showDivider}: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
      py: 0.75,
      ...(showDivider && {borderBottom: `1px solid ${orangeColors[3]}`}),
    }}
  >
    <Box
      sx={{
        width: 7,
        height: 7,
        borderRadius: '50%',
        bgcolor: getWorkforceProfileHighlightDotColor(variant),
        mt: 0.75,
        flexShrink: 0,
      }}
    />
    <Typography variant='body2'>{item}</Typography>
  </Box>
);
